import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SubHeaderService } from '../../core/services/sub-header.service';
import { SubHeader } from '../../core/models/sub-header.model';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
 
  public subHeader: SubHeader = new SubHeader({
    title: "Login",
    buttons: []
  });

  constructor(
    public subHeaderService: SubHeaderService,
    public svc: AuthService,    
  ) { }

  ngOnInit() {
    this.subHeaderService.updateSubHeader(this.subHeader);   
  }

  public login(): void {    
    window.location.href = "/api/login";
  }
}
